export default __webpack_public_path__ + "content/media/25.dd8e8878.jpg";